// extracted by mini-css-extract-plugin
export default {"availabilityTag":"availabilityTag___rVTot"};